import { render, staticRenderFns } from "./Hello_Girl.vue?vue&type=template&id=6980ecf4&scoped=true"
import script from "./Hello_Girl.vue?vue&type=script&lang=js"
export * from "./Hello_Girl.vue?vue&type=script&lang=js"
import style0 from "./Hello_Girl.vue?vue&type=style&index=0&id=6980ecf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980ecf4",
  null
  
)

export default component.exports